export default "__VITE_ASSET__CmS6fy6i__"